var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#4987FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1714 22.2971C26.3766 21.0121 27.9459 20.1714 29.7714 20.1714C31.6886 20.1714 33.5272 20.9661 34.8828 22.3807C36.2384 23.7952 37 25.7138 37 27.7143V38H34.3714V27.7143C34.3714 26.4412 33.8868 25.2203 33.0241 24.3202C32.1615 23.42 30.9914 22.9143 29.7714 22.9143C28.5514 22.9143 27.3814 23.42 26.5187 24.3202C25.6561 25.2203 25.1714 26.4412 25.1714 27.7143V38H22.5429V20.8571H25.1714V22.2971ZM15.9714 18.1143C15.4486 18.1143 14.9471 17.8976 14.5774 17.5118C14.2077 17.126 14 16.6027 14 16.0571C14 15.5116 14.2077 14.9883 14.5774 14.6025C14.9471 14.2167 15.4486 14 15.9714 14C16.4943 14 16.9957 14.2167 17.3654 14.6025C17.7352 14.9883 17.9429 15.5116 17.9429 16.0571C17.9429 16.6027 17.7352 17.126 17.3654 17.5118C16.9957 17.8976 16.4943 18.1143 15.9714 18.1143ZM14.6571 20.8571H17.2857V38H14.6571V20.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaI);
export default __webpack_public_path__ + "static/media/SocialMedia_i.38ba603feed27bd8a7f611184ed7b1a4.svg";
export { ForwardRef as ReactComponent };